import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link, useHistory } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Pagination, Input, Modal, Tooltip, Select, Button, Textarea } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, AddIcon2, SubcategoryIcon } from 'assets/icons';
import { ChatService } from 'services';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {

}

class Information extends React.Component<Props> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		form: INITIAL_STATE,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Base de conocimiento',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading = false, resetItemActive = true) => {
		const res: any = await ChatService.admin.getInformation({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.information?.rows || [],
			last_page: res.information?.count || 1
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la información?',async () => {
			await ChatService.admin.deleteInformation({
				content_id: item.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	render() {
		const { data, visible } = this.state;

		return (
			<div id="profile" className="chat">
				<Modal
		          className="modal-create-information"
		          visible={ visible }
		          title={ (this.state.item ? 'Editar' : 'Nueva') + ' información' }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		            item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="container-table">
					<div className="row">
						<div className="col-md-8">
							<h3>Información registrada</h3>
						</div>
						<div className="col-md-4 text-right">
							<button className="btn btn-add" onClick={ () => this.add() }>
								<img src={ AddIcon } />
								Nuevo
							</button>
						</div>
					</div>
					<hr />
					{
						data.map((item: any) => {
							return (
								<>
									<div className="item">
										<div className="text-right" style={{ marginBottom: '15px' }}>
											{
												checkPermission(Constants.MODULES.CHAT_INFORMATION,'write') && (
													<Tooltip title="Editar">
														<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,item) }>
															<img src={ EditIcon } />
														</a>
													</Tooltip>
												)
											}
											{
												checkPermission(Constants.MODULES.CHAT_INFORMATION,'delete') && (
													<Tooltip title="Eliminar">
														<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,item) }>
															<img src={ TrashIcon } />
														</a>
													</Tooltip>
												)
											}
										</div>
										<Textarea
											disabled={ true }
											rows={ 5 }
											color="white"
											value={ item?.content }
											name="content" 
											placeholder="Contenido"
											onChange={ () => {} } />
									</div>
								</>
							)
						})
					}
					{
						data.length == 0 && (
							<p className="no-items">No se encontraron registros</p>
						)
					}
				</div>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Information);